import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a54cd06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-space-between sm__app-bar_extentions mx-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_sm_text = _resolveComponent("sm-text")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_sm_badge = _resolveComponent("sm-badge")!
  const _component_sm_tabs = _resolveComponent("sm-tabs")!
  const _component_sm_btn_text = _resolveComponent("sm-btn-text")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.app)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(`height:${_ctx.STYLES.APP_BAR_HEIGHT}px`)
        }, null, 4))
      : _createCommentVNode("", true),
    _createVNode(_component_v_app_bar, {
      app: _ctx.app,
      style: _normalizeStyle(_ctx.isModal ? { position: 'fixed', top: '0px', left: '0px', width: '100%' } : {position: 'fixed'}),
      color: "#ffffff",
      height: _ctx.STYLES.APP_BAR_HEIGHT,
      "extension-height": _ctx.STYLES.APP_BAR_EXTENSION_HEIGHT,
      class: "sm__app-bar"
    }, _createSlots({
      prepend: _withCtx(() => [
        (_ctx.leftIcon)
          ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickLeftIcon())),
              ref: "leftVIconRef",
              icon: _ctx.leftIcon,
              density: "compact"
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_title, { class: "mr-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_sm_text, {
              format: "sm__title",
              style: {"white-space":"nowrap"},
              text: _ctx.label,
              class: "sm__app-bar-label"
            }, null, 8, ["text"])
          ]),
          _: 1
        }),
        (_ctx.iconVisible)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.rightThirdIcon)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    icon: "",
                    variant: "text",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click-right-third-icon'))),
                    class: "sm__app-bar-icon mr-6",
                    "max-width": 24,
                    "max-height": 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.rightThirdIcon), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.rightFirstIcon)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickRightFirstIcon())),
                    class: "sm__app-bar-icon",
                    ref: "rightFirstVIconRef"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rightFirstIcon), 1)
                    ]),
                    _: 1
                  }, 512))
                : _createCommentVNode("", true),
              (_ctx.rightSecondIcon)
                ? (_openBlock(), _createBlock(_component_sm_badge, {
                    key: 2,
                    dot: "",
                    visible: _ctx.rightSecondBadgeVisible,
                    class: "sm__app-bar-badge mr-4",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('click-right-second-icon'))),
                    icon: _ctx.rightSecondIcon
                  }, null, 8, ["visible", "icon"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.isExtensionVisible)
        ? {
            name: "extension",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_sm_tabs, {
                  modelValue: _ctx.selectedTab,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTab) = $event)),
                  tabs: Object.values(_ctx.REPAIR_PLAN_TABS).map(e => e.name)
                }, null, 8, ["modelValue", "tabs"]),
                _createVNode(_component_sm_btn_text, {
                  text: "更新履歴",
                  class: "my-auto",
                  onClickBtn: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('click-extension-btn')))
                })
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["app", "style", "height", "extension-height"])
  ]))
}